import { useEffect, useState } from 'react';
import { api } from '../api';

interface ScheduledActivity {
  id: string;
  name: string;
  schedule: string;
  actionType: string;
  status: string;
  nextRunAt: string | null;
}

export function SchedulerPage() {
  const [items, setItems] = useState<ScheduledActivity[]>([]);
  const [name, setName] = useState('');
  const [schedule, setSchedule] = useState('0 9 * * 1');
  const [actionType, setActionType] = useState<'create_task' | 'send_reminder'>('create_task');
  const [taskTitle, setTaskTitle] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setItems(await api.get<ScheduledActivity[]>('/api/scheduled-activities').catch(() => []));
  }
  useEffect(() => {
    void load();
  }, []);

  async function create() {
    if (!name.trim()) return;
    setError(null);
    try {
      await api.post('/api/scheduled-activities', {
        name,
        schedule,
        actionType,
        actionConfig: actionType === 'create_task' ? { title: taskTitle || name } : { title: name },
      });
      setName('');
      setTaskTitle('');
      await load();
    } catch {
      setError('Create failed — check the cron expression (e.g. "0 9 * * 1").');
    }
  }
  async function remove(id: string) {
    await api.del(`/api/scheduled-activities/${id}`);
    await load();
  }

  return (
    <div className="card">
      <h1>Scheduler</h1>
      <p className="muted">Recurring automation via cron. e.g. <code>0 9 * * 1</code> = Mondays 9am.</p>
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}

      <table className="grid">
        <thead><tr><th>Name</th><th>Schedule</th><th>Action</th><th>Next run</th><th></th></tr></thead>
        <tbody>
          {items.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td><code>{s.schedule}</code></td>
              <td>{s.actionType}</td>
              <td>{s.nextRunAt ? new Date(s.nextRunAt).toLocaleString() : '—'}</td>
              <td><button className="btn" onClick={() => void remove(s.id)}>Delete</button></td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5} className="empty">No scheduled activities.</td></tr>}
        </tbody>
      </table>

      <h2 style={{ fontSize: '1.05rem' }}>New scheduled activity</h2>
      <div className="stack">
        <input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
        <div className="row">
          <input placeholder="cron e.g. 0 9 * * 1" value={schedule} onChange={(e) => setSchedule(e.target.value)} />
          <select value={actionType} onChange={(e) => setActionType(e.target.value as typeof actionType)}>
            <option value="create_task">Create task</option>
            <option value="send_reminder">Send reminder</option>
          </select>
        </div>
        {actionType === 'create_task' && (
          <input placeholder="Task title (defaults to name)" value={taskTitle} onChange={(e) => setTaskTitle(e.target.value)} />
        )}
        <button className="btn btn-primary" onClick={() => void create()}>Create</button>
      </div>
    </div>
  );
}
